import { semanticColors, typography } from '@moderneinc/design-system-tokens';
import { Stack, Typography } from '@mui/material';
import type { FunctionComponent } from 'react';
import { CORPORATE_SITE_URL, SUPPORT_EMAIL } from '../../../constants/general';
import { Link } from '../../utilities/moderne-link/moderne-link.component';

export type LoginScreenCustomization = {
  text?: string;
  links?: Array<{ label: string; uri: string }>;
};

type SignInFooterProps = {
  customization?: LoginScreenCustomization;
};

const footerTextSx = {
  fontWeight: typography.fontWeight.medium,
  fontSize: (theme) => theme.typography.pxToRem(14),
  lineHeight: '36px',
  color: semanticColors.color.text.primary
} as const;

const footerLinkSx = { color: semanticColors.color.text.primary } as const;

const DEFAULT_LINKS: NonNullable<LoginScreenCustomization['links']> = [
  { label: 'Learn about Moderne', uri: CORPORATE_SITE_URL },
  { label: 'Contact support', uri: `mailto:${SUPPORT_EMAIL}` }
];

export const SignInFooter: FunctionComponent<SignInFooterProps> = ({
  customization
}) => {
  const links =
    customization?.links && customization.links.length > 0
      ? customization.links
      : DEFAULT_LINKS;

  return (
    <Stack sx={{ alignItems: 'center' }}>
      {links.map((link) => (
        <Typography key={link.uri} variant="body" sx={footerTextSx}>
          <Link href={link.uri} external underline="always" sx={footerLinkSx}>
            {link.label}
          </Link>
        </Typography>
      ))}
    </Stack>
  );
};
